import * as React from 'react';
import { useSetRecoilState } from 'recoil';
import { IDynamicTableState } from '../../../../interfaces/tables';
import { setTableColumnChecked, tablesAtom } from '../../../../store/recoil/TableState';

interface IComponentProps {
  system?: boolean;
  visible: boolean;
  columnId: string;
  required: boolean;
  title: string;
  key: string;
  id: string;
  tableName: string;
}

export default function Item({ ...props }: IComponentProps) {
  const setTables = useSetRecoilState<IDynamicTableState>(tablesAtom);

  const handleSetChecked = () => {
    setTables((oldState) =>
      setTableColumnChecked(oldState, {
        name: props.tableName,
        columnId: props.columnId,
      })
    );
  };

  if (props.system) {
    return null; // Return nothing if props.system is true
  }

  return (
    <div className="e-checkbox px-2 py-xs d-block" key={props.key} style={{ display: 'block' }}>
      <label>
        <input
          className="columnsCheckboxes"
          data-cy={`table-select-columns-${props.id}`}
          onChange={handleSetChecked}
          type="checkbox"
          checked={props.visible}
          disabled={props.required}
        />
        <span>{props.title}</span>
      </label>
    </div>
  );
}
